import { Fragment, useEffect, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NumeratorsCrumbs } from '../constants';
import FormNumerator, { NumeratorForm } from 'system/components/numerators/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __OPERATION__MANAGEMENT__ } from 'shell/constants/environment';
import { useNavigate, useParams } from 'react-router';
import { HttpResponse } from 'shell/models/http-response';
import { Numerator } from 'shell/models/numerator';

const NumeratorsDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const {
    get: getNumerator,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Numerator>>(
    `${__OPERATION__MANAGEMENT__}/numeratore/documenti/${params.codiceEnte}/${params.tipoRegistro}/${params.annoDocumento}`
  );

  useEffect(() => {
    getNumerator();
  }, []);

  const numerator: NumeratorForm = useMemo(() => {
    const numeratorPayload = data?.payload;
    if (!numeratorPayload || !!error) {
      return {};
    }
    return {
      id: data?.payload.key.codiceEnte,
      numeratorRegisterType: data?.payload.key.tipoRegistro,
      year: data?.payload.key.annoDocumento.toString(),
      description: data?.payload.descrizioneNumeratore?.toString(),
      currentNumerator: data?.payload.progressivoDocumento?.toString(),
    } as NumeratorForm;
  }, [data, error]);

  return (
    <Fragment>
      <Breadcrumbs items={[...NumeratorsCrumbs, { name: 'Dettaglio Numeratore' }]} />
      {!loading && data ? (
        <FormNumerator
          title="Dettaglio Numeratore"
          onOk={() => {
            return;
          }}
          onCancel={() => {
            navigate('/sistema/numeratori');
          }}
          initialValues={numerator}
          disabled
        />
      ) : undefined}
    </Fragment>
  );
};

NumeratorsDetailPage.displayName = 'Numerators detail page component';

export default NumeratorsDetailPage;
